<template>
  <div id="forgotPasswordWrapper">
    <div class="columns">
      <div class="column is-half is-offset-one-quarter">
        <div class="box">
          <my-title>Wachtwoord vergeten</my-title>

          <div class="notification is-success" :class="{ 'is-hidden': !saved }">
            Uw verzoek is verzonden. Indien het e-mail adres bij ons bekend is ontvangt u een e-mail met daarin instructies om uw wachtwoord te herstellen.
          </div>

          <div class="field">
            <label class="label">E-mail adres</label>
            <div class="control">
              <input type="text" class="input" v-model="email">
            </div>
          </div>

          <save-buttons
            :disabled="!valid"
            @save="send"
            @cancel="cancel"
            saveCaption="Versturen"
            cancelCaption="Terug naar inloggen">
          </save-buttons>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MyTitle from '@/components/modules/Title'
import SaveButtons from '@/components/modules/SaveButtons'

export default {
  props: [
    'fromLogin'
  ],
  components: {
    MyTitle,
    SaveButtons
  },
  data () {
    return {
      email: null
    }
  },
  computed: {
    ...mapGetters({
      saved: 'account/saved'
    }),
    valid () {
      return true
    }
  },
  created () {
    this.email = this.fromLogin
  },
  methods: {
    send () {
      this.$store.dispatch('account/forgot', { email: this.email })
    },
    cancel () {
      this.$router.go(-1)
    }
  }
}
</script>
